export default __webpack_public_path__ + "1.18.21/static/media/link-arrow.a76636ac.svg";